import { useSettings } from 'connectors/Settings/Settings';
import { getStoresAvailabilityMessage } from 'helpers/availability/pickupPointAvailability';
import useTranslation from 'next-translate/useTranslation';
import { twJoin } from 'tailwind-merge';

type ProductAvailableStoresCountProps = {
    isMainVariant: boolean;
    isInCentralStore: boolean;
    availableStoresCount: number;
    deliveryDaysFromCentralStore: string | null;
};

export const getProductAvailabilityEShopTwClass = (isInStock: boolean): string => {
    return isInStock ? 'text-green' : 'text-grayDark';
};
export const productAvailabilityTwClass = 'mt-2 text-small font-medium leading-4 text-grayDark';

const ProductAvailableStoresCount: FC<ProductAvailableStoresCountProps> = ({
    availableStoresCount,
    deliveryDaysFromCentralStore,
    isInCentralStore,
    isMainVariant,
}) => {
    const testIdentifier = 'blocks-product-availability';
    const settings = useSettings();
    const { t } = useTranslation();

    if (isMainVariant) {
        return null;
    }

    const isInCentralStoreWithEnabledReservationsAndNowhereElse =
        deliveryDaysFromCentralStore !== null && isInCentralStore && availableStoresCount === 0;

    return (
        <div
            className={twJoin('text-small leading-4', availableStoresCount !== 0 ? 'text-green' : 'text-grayDark')}
            data-testid={testIdentifier}
        >
            {getStoresAvailabilityMessage(
                isInCentralStoreWithEnabledReservationsAndNowhereElse,
                availableStoresCount,
                deliveryDaysFromCentralStore,
                settings?.isAnyStockStore,
                t,
            )}
        </div>
    );
};

export default ProductAvailableStoresCount;
